import {
  Heading,
  Text,
  Spinner,
  SpinnerColor,
  LiliOtp,
  FontWeight,
  LiliOtpType,
} from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { useBlocker } from '@tanstack/react-router';
import { ControllerWrapper } from '@Hooks/index';
import { OnboardingFormFields } from '@Types/types';
import { useBoundStore } from '@Store/useBoundStore';
import { ReactComponent as ShieldIcon } from '@Assets/icons/shield.svg';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { useIdVerificationLogic } from './hooks/useIdVerificationLogic';

export const UboIdVerificationPage = () => {
  const { t } = useTranslation('uboOnboarding');
  const isUsFlow = useBoundStore((state) => state.isUsFlow);
  const { formMethods, handleValidateCode, isLoading, customError, setCustomError } =
    useIdVerificationLogic();

  useBlocker({
    shouldBlockFn: ({ next }) => {
      return next.routeId !== routesModel[RoutesMap.UBO_ONBOARDING_CREATE_PASSWORD].path;
    },
  });

  return (
    <FormProvider {...formMethods}>
      <div className=' mb-64 flex flex-col items-center justify-center  bg-surface-primary-bw-02 gap-0'>
        <ShieldIcon className='phone:hidden sm:block w-[90px] h-[90px] text-primary' />

        <Heading.H3 fontWeight={FontWeight.MEDIUM} className='text-center phone:hidden md:block'>
          <Trans
            ns='uboOnboarding'
            i18nKey={isUsFlow ? 'idVerification.title' : 'idVerification.nonUsTitle'}
          />
        </Heading.H3>
        <Text.H6 fontWeight={FontWeight.SEMIBOLD} className='text-center md:hidden'>
          <Trans
            ns='uboOnboarding'
            i18nKey={isUsFlow ? 'idVerification.title' : 'idVerification.nonUsTitle'}
          />
        </Text.H6>
        <Text.H9 className='text-text-main-secondary text-center mt-3'>
          {t('idVerification.subtitle')}{' '}
        </Text.H9>
        <div className='flex gap-4 mt-12'>
          <ControllerWrapper name={OnboardingFormFields.MFA_OTP}>
            {({ error }) => (
              <LiliOtp
                key={'id-verification-otp'}
                id={OnboardingFormFields.MFA_OTP}
                type={LiliOtpType.CUSTOM}
                pattern={isUsFlow ? '^[0-9]+$' : '^[A-Za-z0-9-]+$'}
                maxLength={4}
                onCompleted={handleValidateCode}
                autoFocus
                disabled={isLoading}
                onFocus={() => setCustomError('')}
                errorMessage={customError || error?.message}
              />
            )}
          </ControllerWrapper>
        </div>

        {isLoading && (
          <div className='mt-4'>
            <Spinner height='24px' width='24px' spinnerColor={SpinnerColor.Blue} />
          </div>
        )}
      </div>
    </FormProvider>
  );
};

export default UboIdVerificationPage;
